import React, { PureComponent } from 'react';
import Dropdown from '../standardAttributes/Dropdown';
import { getNodeInfo } from '../../../helper/config';
import message from '../../../helper/message';

export default class AboveOverheadShelving extends PureComponent {
  removeModel = (block, newAppState) => {
    const { actions, configuration, attributeName } = this.props;
    const { modelId } = configuration[attributeName];
    const uprightFrontBlock = configuration.uprights.blocks.uprightFront;
    if (modelId) {
      block.unoccupyBlocks(modelId);
      uprightFrontBlock.unoccupyBlocks(modelId);
      newAppState = actions.removeModel(modelId, newAppState);
    }
    return newAppState;
  };

  updateState = (value, importState, newAppState) => {
    const {
      actions,
      configuration,
      models,
      activeTab,
      attributeName,
      appApi,
    } = this.props;
    const uprightFrontBlock = configuration.uprights.blocks.uprightFront;
    const nodeInfo = getNodeInfo(appApi.config.getProduct(value));
    const insertion = uprightFrontBlock.forceInsert(
      nodeInfo,
      0,
      0,
      blockModels =>
        blockModels.forEach(({ modelId, valid }) => {
          if (!valid) {
            const { attribute: shelfAttribute, value: shelfValue } = models[
              modelId
            ];
            newAppState = actions.removeModel(modelId, newAppState);
            newAppState = actions.setConfiguration(
              { attribute: shelfAttribute, value: shelfValue, change: modelId },
              newAppState
            );
            uprightFrontBlock.unoccupyBlocks(modelId);
          }
        })
    );
    if (!insertion.isInsertionPossible) {
      message.error(
        `Fail to insert ${attributeName}, please check either the dimension  or the compatibility of product ${value}!`
      );
      return newAppState;
    }

    uprightFrontBlock.occupyBlocks(importState.modelId, insertion);
    const parent = configuration.uprights.modelId;
    newAppState = actions.addModel(
      importState,
      { tab: activeTab, attribute: attributeName, value, parent },
      newAppState
    );
    newAppState = actions.setConfiguration(
      { attribute: attributeName, value: { ...importState, value } },
      newAppState
    );
    return newAppState;
  };

  render() {
    return (
      <Dropdown
        {...this.props}
        removeModel={this.removeModel}
        updateState={this.updateState}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/nonStandardAttributes/AboveOverheadShelving.js